import { ReactNode, ReactElement } from 'react';
import { IFeatureProps } from 'mod/featureV2/interface';
import { IFeatureBanner, IBanner } from 'mod/featureV2/interface/banner';
import { theme } from 'pro/config/theme';
import { isPhone } from 'base/utils/client';
import { merge } from 'ava-util/dist/data';
import { Banner } from 'mod/featureV2/Banner';
import { getBannerTrackData } from 'mod/featureV2/Banner/utils';
import { Row, Col } from '@base/lib/ThemeGrid';
import Tracker from '@base/lib/Tracker';
import { IBannerProps } from 'mod/featureV2/Banner/interface';

export type IProps<T extends IBanner = IBanner> = IFeatureProps<IFeatureBanner<T>> & {
    containerWidth?: number;
    renderBanner?: (bannerProps: IBannerProps<T>) => ReactNode;
};

function getContainerWidth(fullScreen: boolean, sideSpace: boolean): number {
    const fullWidth = fullScreen ? (isPhone ? 375 : 1920) : theme.wrapperWidth;
    const sideWidth = sideSpace ? theme.siteSpace * 2 : 0;
    return fullWidth - sideWidth;
}

const defaultHeightMap = {
    1: 300,
    2: 410,
    3: 360,
};

export function GridBanner<T extends IBanner>(props: IProps<T>): ReactElement {
    const {
        feature: {
            moduleId,
            config,
            list
        },
        renderBanner,
    } = props;

    const {
        width,
        height = 200,
        fullScreen = false,
        sideSpace = false,
        largeScreenHeightFixed,
        bgColor = false,
        threshold,
        playThreshold,
        // column = 1,
        // spaceBetweenColumns = 0,
        grid = {},
        radius,
    } = config;

    const column = grid.column || config.column || 1;
    const gutter = grid.gutter || config.spaceBetweenColumns || 0;
    const gutterX = typeof gutter === 'number' ? gutter : gutter[0];

    const containerWidth = props.containerWidth || getContainerWidth(fullScreen, sideSpace);
    const bannerWidth = Math.round((containerWidth + gutterX) / column) - gutterX;
    // 旧的 tiledBanner 可能没有 width
    let bannerHeight = typeof width === 'number'
        ? Math.round((bannerWidth * Number(height)) / width)
        : (height ? (isPhone ? (Number(height) / 2) : height) : defaultHeightMap[column]);

    return (
        <Row colsPerRow={column} gutter={gutter} className={'g-banner-list'}>
            {list.map((item, index) => {
                const bannerProps: IBannerProps<T> = {
                    banner: merge({ bgColor }, item) as T,
                    width: bannerWidth,
                    height: bannerHeight,
                    largeScreenHeightFixed: largeScreenHeightFixed && fullScreen && column === 1 && !isPhone,
                    radius,
                    threshold,
                    playThreshold
                };
                return (
                    <Tracker key={index} data={getBannerTrackData(moduleId, item, index)}>
                        <Col key={index} className={'g-banner-item'}>
                            {typeof renderBanner === 'function' ? renderBanner(bannerProps) : <Banner {...bannerProps}/>}
                        </Col>
                    </Tracker>
                )
            })}
        </Row>
    )
}
